import algoliasearch from 'algoliasearch/lite';
import instantsearch from 'instantsearch.js';
import { connectSearchBox, connectHits } from 'instantsearch.js/es/connectors';
import { configure } from 'instantsearch.js/es/widgets';
//import { analytics } from 'instantsearch.js/es/widgets';

import renderSearchBox from './SearchBox';
import renderHits from './SearchHits';

const searchClient = algoliasearch(
  'OJTPVO4RH0',
  'b641732c895d70fa8124a578b7ea729c',
);

const customSearchBox = connectSearchBox(renderSearchBox);
const customHits = connectHits(renderHits);

//const dataLayer = window.dataLayer || null;

export default (searchForm, onSearchCallback, onInputCallback = () => {}) => {
  const searchInput = searchForm.querySelector('input');
  const searchResults = searchForm.querySelector('.js-tindex-result');

  const index = instantsearch({
    indexName: 'products_test_4dig',
    searchClient,
  });
  let selectedHit = null;

  document.addEventListener('click', function (e) {
    if (e.target !== searchInput && searchForm.classList.contains('active')) {
      searchForm.classList.remove('active');
      searchInput.blur();
    }
  });

  index.addWidgets([
    configure({}),
    customSearchBox({
      container: searchForm,
      onSearch() {
        if (selectedHit) {
          onSearchCallback(selectedHit.value);
          searchInput.blur();
        }
      },
      onClear() {
        if (selectedHit) {
          selectedHit = null;
          onSearchCallback(selectedHit);
        }
      },
      onInput() {
        if (selectedHit) {
          onInputCallback();
        }
        selectedHit = null;
      },
      onSelect(action) {
        const selected = searchResults.querySelector(
          '.autocomplete__item.selected',
        );
        if (selected) {
          let sibling =
            action === 'down' ? selected.nextSibling : selected.previousSibling;
          if (!sibling) {
            // resume from top/bottom
            sibling =
              action === 'down'
                ? searchResults.querySelector('.autocomplete__item:first-child')
                : searchResults.querySelector('.autocomplete__item:last-child');
          }
          selected.classList.remove('selected');
          sibling.classList.add('selected');
          sibling.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
          });
        } else {
          const selectable =
            action === 'down'
              ? searchResults.querySelector('.autocomplete__item:first-child')
              : searchResults.querySelector('.autocomplete__item:last-child');
          if (selectable) {
            selectable.classList.add('selected');
            selectable.scrollIntoView({
              behavior: 'smooth',
              block: 'nearest',
            });
          }
        }
      },
      onSubmit() {
        const selected = searchResults.querySelector('.selected');
        if (selected) {
          selected.classList.remove('selected');
          selected.click();
        } else if (selectedHit) {
          onSearchCallback(selectedHit.value);
          searchInput.blur();
        }
      },
      onBlur() {
        if (searchForm.classList.contains('active')) {
          searchForm.classList.remove('active');
          searchInput.blur();
        }
      },
    }),
    customHits({
      container: searchResults,
      onSelect(hit) {
        selectedHit = hit;
        index.helper.setQuery(hit.label).search();
        onSearchCallback(hit.value);
      },
    }),
    /*
    analytics({
      pushFunction(formattedParameters, state, results) {
        if (dataLayer && state.query !== '') {
          console.log('Search analytics: ', state.query);
          dataLayer.push({
            event: 'search',
            'Search Query': state.query,
            'Facet Parameters': formattedParameters,
            'Number of Hits': results.nbHits,
          });
        }
      },
      delay: 2000,
      triggerOnUIInteraction: true,
    }),
  */
  ]);

  index.start();

  return index;
};
